import { render, staticRenderFns } from "./EndCardVersionSettings.vue?vue&type=template&id=12596d04&lang=pug"
import script from "./EndCardVersionSettings.vue?vue&type=script&lang=js"
export * from "./EndCardVersionSettings.vue?vue&type=script&lang=js"
import style0 from "./EndCardVersionSettings.vue?vue&type=style&index=0&id=12596d04&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports